<template>
  <div>
    <!-- Button trigger modal -->
    <!-- <button type="button" class="btn btn-primary" @click="showModal">
      Open QC Done Modal
    </button> -->

    <!-- Modal -->
    <div 
      class="modal fade" 
      id="modalAccessoriesQcDone" 
      tabindex="-1" 
      role="dialog" 
      aria-labelledby="qcDoneModalLabel" 
      ref="modal"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h5 class="modal-title" id="qcDoneModalLabel">QC Done</h5>
            <button type="button" class="close" @click="closeModal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <!-- Modal Body -->
          <div class="modal-body">
            <!-- Order Info -->
            <div class="mb-3">
              <h6 class="font-weight-bold mb-2">Order Info</h6>
              <!-- {{ orderData }} -->
              <div class="p-3 bg-light rounded border-card">
                <div class="mb-1">{{ orderData.companyName }}</div>
                <div v-if="orderData.orderCode" class="text-primary" style="cursor: pointer;" @click="toOrderDetail(orderData.orderId, orderData.orderCode,orderData.companyId)">{{orderData.orderCode}}</div>
              </div>
            </div>

            <div v-if="orderData.dataAccessories && !orderData.dataAccessories.batchNo">
            <!-- Accessories -->
            <div class="mb-3">
              <h6 class="font-weight-bold mb-2">Accessories</h6>
              <div class="p-3 bg-light rounded border-card">
                <div class="mb-2">{{ orderData.dataAccessories ? orderData.dataAccessories.itemName : '' }}</div>
                <div class="text-muted">
                  <strong>Total Units:</strong> {{ orderData.dataAccessories ? orderData.dataAccessories.qty : '' }}
                </div>
              </div>
            </div>

            <!-- QC Results -->
            <div class="row mb-3">
              <div class="col-md-6">
                <label class="font-weight-bold">Hasil QC - Ready Stock</label>
                <input 
                  type="number" 
                  class="form-control" 
                  v-model.number="qcReadyStock"
                  min="0"
                  :max="orderData.dataAccessories? orderData.dataAccessories.qty : 0"
                >
                <small class="text-muted">Total: {{ totalQC }}/{{ orderData.dataAccessories ? orderData.dataAccessories.qty : 0}} units</small>
              </div>
              <div class="col-md-6">
                <label class="font-weight-bold">Hasil QC - Trouble</label>
                <input 
                  type="number" 
                  class="form-control" 
                  v-model.number="qcTrouble"
                  min="0"
                  :max="orderData.dataAccessories ? orderData.dataAccessories.qty : 0"
                >
              </div>
            </div>
            </div>

            <!-- untuk yang punya batch number -->
            <div v-else>
              <div class="mb-3">
              <h6 class="font-weight-bold mb-2">Product Info</h6>
                <div class="p-3 bg-light rounded border-card">
                  <!-- Category label -->
                  <div class="text-muted small mb-1">Accessories</div>
                  <!-- Item Name -->
                  <div class="font-weight-bold mb-3">
                    {{ orderData.dataAccessories ? orderData.dataAccessories.itemName : '-' }}
                  </div>
                  <!-- Detail Grid -->
                  <div class="row">
                    <div class="col-6 mb-2">
                      <div class="text-muted small">Product Code</div>
                      <div>{{ orderData.dataAccessories ? orderData.dataAccessories.itemCode || '-' : '-' }}</div>
                    </div>
                    <div class="col-6 mb-2">
                      <div class="text-muted small">Serial Number</div>
                      <div>{{ orderData.dataAccessories ? orderData.dataAccessories.serialNumber || '-' : '-' }}</div>
                    </div>
                    <div class="col-6">
                      <div class="text-muted small">Stock Code</div>
                      <div>{{ orderData.dataAccessories ? orderData.dataAccessories.stockCode || '-' : '-' }}</div>
                    </div>
                    <div class="col-6">
                      <div class="text-muted small">Batch Number</div>
                      <div>{{ orderData.dataAccessories ? orderData.dataAccessories.batchNumber || '-' : '-' }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Warehouse -->
            <div class="row mb-3" v-if="orderData.dataAccessories && !orderData.dataAccessories.batchNo">
              <div class="col-md-6">
                <label class="font-weight-bold">Warehouse - Ready Stock</label>
                <multiselect v-model="warehouseReadyStock" :options="warehouseList" :allow-empty="true" :select-label="''" :deselect-label="''" placeholder="Ready Stock WH" :multiple="false" :close-on-select="true" default></multiselect>
              </div>
              <div class="col-md-6">
                <label :class="`font-weight-bold ${warehouseTrouble ? '' : 'text-muted'}`">Warehouse - Trouble</label>
                <input 
                  type="text" 
                  class="form-control" 
                  v-model="warehouseTrouble"
                  :disabled=true
                >
              </div>
            </div>

            <div v-else>
              <div class="mb-3">
                <label class="font-weight-bold d-block mb-2">Hasil QC</label>
                <div class="row no-gutters">
                  <div class="col-6 pr-2">
                    <div 
                      class="qc-option-card p-3 rounded border d-flex align-items-center justify-content-between"
                      :class="hasilQC === 'ready' ? 'border-primary' : 'border-card'"
                      style="cursor: pointer;"
                      @click="hasilQC = 'ready'"
                    >
                      <span class="font-weight-500">Ready Stock</span>
                      <div class="custom-control custom-radio">
                        <input 
                          type="radio" 
                          class="custom-control-input" 
                          id="radioReady"
                          name="hasilQC" 
                          value="ready" 
                          v-model="hasilQC"
                        >
                        <label class="custom-control-label" for="radioReady"></label>
                      </div>
                    </div>
                  </div>

                  <!-- Trouble Column -->
                  <div class="col-6 pl-2">
                    <div 
                      class="qc-option-card p-3 rounded border d-flex align-items-center justify-content-between"
                      :class="hasilQC === 'trouble' ? 'border-primary' : 'border-card'"
                      style="cursor: pointer;"
                      @click="() =>{hasilQC = 'trouble'; warehouseTrouble = 'Trouble WH';}"
                    >
                      <span class="font-weight-500">Trouble</span>
                      <div class="custom-control custom-radio">
                        <input 
                          type="radio" 
                          class="custom-control-input" 
                          id="radioTrouble"
                          name="hasilQC" 
                          value="trouble" 
                          v-model="hasilQC"
                        >
                        <label class="custom-control-label" for="radioTrouble"></label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Warehouse -->
              <div class="mb-3" v-if="hasilQC == 'ready'">
                <label class="font-weight-bold">Warehouse - Ready Stock</label>
                <multiselect 
                  v-model="warehouseReadyStock" 
                  :options="warehouseList" 
                  :allow-empty="true" 
                  :select-label="''" 
                  :deselect-label="''" 
                  placeholder="Pilih warehouse" 
                  :multiple="false" 
                  :close-on-select="true"
                ></multiselect>
              </div>
              <div class="mb-3" v-if="hasilQC == 'trouble'">
                <label class="font-weight-bold">Warehouse - Trouble</label>
                <input 
                  type="text" 
                  class="form-control" 
                  v-model="warehouseTrouble"
                  :disabled=true
                >
              </div>
            </div>
          </div>
          <!-- Modal Footer -->
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">
              Cancel
            </button>
            <button type="button" class="btn btn-primary" @click="saveQC">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import Swal from "sweetalert2";
export default {
  name: 'ModalAccessoriesQcDone',
  props: ['orderData','toOrderDetail','warehouseList'],
  components: {
    Multiselect,
  },
  data() {
    return {
      qcReadyStock : 0,
      qcTrouble : 0,
      warehouseReadyStock : '',
      warehouseTrouble : '',
      warehouseTroubleOptions : [],
      warehouseReadyOptions : [],
      hasilQC : '',
    }
  },
  computed: {
    totalQC() {
      return this.qcReadyStock + this.qcTrouble;
    }
  },
  methods: {
    showModal() {
      $(this.$refs.modal).modal('show');
    },
    closeModal() {
      this.qcReadyStock = 0,
      this.qcTrouble = 0,
      this.warehouseReadyStock = '',
      this.warehouseTrouble = '',
      $(this.$refs.modal).modal('hide');
    },
    getTroubleWarehouse() {
      this.warehouseTroubleOptions = this.warehouseList.map(item => {
        const whShards = item.split('-')
        const trouble = whShards[0] + 'Trouble -' + whShards[1]
        return trouble
      })

    },
    saveQC() {
      const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
              confirmButton: "btn btn-primary ml-2",
              cancelButton: "btn btn-danger",
            },
            buttonsStyling: false,
          });
      // Validasi
      if (Number(this.totalQC) !== Number(this.orderData.dataAccessories.qty)) {
        swalWithBootstrapButtons.fire({
            title: "Failed",
            text: `Total QC harus sama dengan Total Units (${this.orderData.dataAccessories.qty})`,
            icon: "error",
          }).then(result => {
            this.closeModal('modalAccessoriesQcDone')
          })
        return;
      }
      
      if (!this.warehouseReadyStock && this.qcReadyStock > 0) {
         swalWithBootstrapButtons.fire({
            title: "Failed",
            text: 'Pilih warehouse untuk Ready Stock',
            icon: "error",
          }).then(result => {
            this.closeModal('modalAccessoriesQcDone')
          })
        return;
      }
  
      const {orderId, dataAccessories, ticketNo} = this.orderData
      const {itemCode, itemGroup, itemName, batchNo} = dataAccessories
      const payload = {
        orderId: orderId,
        itemCode,
        itemGroup,
        itemName,
        qtyGoodStock: this.qcReadyStock || 0,
        qtyTrouble: this.qcTrouble || 0, 
        sourceWarehouse: this.orderData.fromWarehouse,
        parentWarehouse: this.warehouseReadyStock,
        status : batchNo ? this.hasilQC : '',
        batchNo : batchNo,
        ticketNo: ticketNo || '',
      }
      
      // console.log(payload)
      this.processAccessoriesQcDone(payload)
      this.closeModal();
    },
    processAccessoriesQcDone(payload) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      this.$http.post(process.env.QC_DONE_ACCESSORIES, payload, {
          timeout: 30 * 1000,
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then(res => {
          if (res.data.status == 200) {
            swalWithBootstrapButtons.fire({
              title: "Success",
              text: `Data has been saved successfully.`,
              icon: "success",
            }).then(result => {
              this.closeModal()
              window.location.reload()
            })
          } else {
            swalWithBootstrapButtons.fire({
              title: "Sorry",
              text: `${res.data.message}`,
              icon: "error",
            })
          }
        })
        .catch(error => {
          this.loadingTable = false
          swalWithBootstrapButtons.fire({
            title: "Sorry",
            text: `${error.response.data.message}`,
            icon: "error",
          })
        })
    },
  },
  watch: {
    warehouseReadyStock(val) {
      if(this.qcTrouble > 0) {
        const shards = val.split('-')
        const trouble = shards[0] + 'Trouble -' + shards[1]
        this.warehouseTrouble = trouble
      }
    },
    qcTrouble(val) {
      if(!val) {
        this.warehouseTrouble = ''
      } else {
        if(this.qcReadyStock > 0 && this.warehouseReadyStock) {
          const shards = this.warehouseReadyStock.split('-')
          const trouble = shards[0] + 'Trouble -' + shards[1]
          this.warehouseTrouble = trouble
        }
      }
    },
  },
}
</script>

<style scoped>
.wh-trouble {
  background-color: #F8F9FA;
}
.modal-header {
  border-bottom: 1px solid #dee2e6;
}

.modal-footer {
  border-top: 1px solid #dee2e6;
}

.border-card {
  border: 1px solid  #D1D9E2;;
}

.bg-light {
  background-color: #f8f9fa !important;
}

.font-weight-bold {
  font-weight: 600;
}

h6 {
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
}

.form-control:disabled {
  background-color: #e9ecef;
  opacity: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/QC/CustomComponent/ModalAccessoriesQcDone.vue